export default {
  // === NAVBAR ===
  "nav.home": "Início",
  "nav.guides": "Guias",
  "nav.safety": "Segurança",
  "nav.select_category": "Selecionar Categoria",
  "nav.shop_guide": "Guia de Compras",

  // === HERO ===
  "hero.title_line1": "Melhor CSSBuy",
  "hero.title_line2": "Spreadsheet 2026",
  "hero.subtitle": "Descubra a maior coleção de links CSSBuy atualizados, vendedores confiáveis, guias completos e as melhores ofertas para streetwear, sneakers e moda.",
  "hero.cta1": "cssbuy sheet",
  "hero.cta2": "buy it now",
  "hero.trust1": "✓ Atualizado diariamente",
  "hero.trust2": "✓ Vendedores verificados",
  "hero.trust3": "✓ Guias seguros",
  "hero.trust4": "✓ Informações gratuitas",

  // === BENEFITS ===
  "benefits.title": "Por que usar nosso CSSBuy Spreadsheet?",
  "benefits.1": "Links organizados",
  "benefits.2": "Vendedores selecionados",
  "benefits.3": "Atualizações frequentes",
  "benefits.4": "Guias detalhados",
  "benefits.5": "Dicas de segurança",
  "benefits.6": "Economia de tempo",

  // === SOCIAL PROOF ===
  "social.title": "Mais de 10.000 usuários consultam nossos guias mensalmente.",
  "social.sub1": "Atualizações semanais.",
  "social.sub2": "Conteúdo independente.",
  "social.sub3": "Informações verificadas.",

  // === COMPARISON ===
  "comparison.title": "Comparação",
  "comparison.feature": "Recursos",
  "comparison.us": "Nosso CSSBuy Spreadsheet",
  "comparison.others": "Outros Sites",
  "comparison.row1": "Atualizações",
  "comparison.row1_us": "Diárias",
  "comparison.row1_other": "Raras",
  "comparison.row2": "Guias",
  "comparison.row2_us": "Sim",
  "comparison.row2_other": "Não",
  "comparison.row3": "Segurança",
  "comparison.row3_us": "Sim",
  "comparison.row3_other": "Limitada",
  "comparison.row4": "Vendedores",
  "comparison.row4_us": "Verificados",
  "comparison.row4_other": "Desconhecidos",
  "comparison.row5": "Organização",
  "comparison.row5_us": "Excelente",
  "comparison.row5_other": "Média",

  // === CATEGORIES ===
  "categories.title": "Categorias Populares",
  "categories.subtitle": "Navegue por",
  "categories.cta": "Ver Categoria",

  // === ARTICLE ENTRY ===
  "article.label": "(Guia Atualizado Junho 2026)",
  "article.title_line1": "O Guia Definitivo",
  "article.title_line2": "para CSSBuy Sheets",
  "article.excerpt": "Aprenda a encontrar os melhores vendedores, utilizar links atualizados e navegar com segurança no universo CSSBuy. Um guia completo criado por especialistas independentes.",
  "article.author": "Equipe CSSBuy Guides",
  "article.read_more": "Ler Guia Completo",

  // === FAQ ===
  "faq.title": "Perguntas Frequentes",
  "faq.q1": "O CSSBuy Spreadsheet é gratuito?",
  "faq.a1": "Sim. Todo o conteúdo do nosso site é 100% gratuito. Disponibilizamos links organizados, guias detalhados e informações verificadas sem qualquer custo para os usuários.",
  "faq.q2": "O CSSBuy é seguro?",
  "faq.a2": "Sim, quando utilizado corretamente. Nossos guias ensinam as melhores práticas para utilizar o CSSBuy com segurança, desde a escolha de vendedores verificados até dicas de proteção durante as transações.",
  "faq.q3": "Como encontrar vendedores confiáveis?",
  "faq.a3": "Através dos nossos guias detalhados. Mantemos uma lista constantemente atualizada de vendedores verificados, com avaliações e feedback da comunidade para ajudar você a fazer as melhores escolhas.",
  "faq.q4": "Qual é o melhor spreadsheet?",
  "faq.a4": "O melhor spreadsheet é aquele atualizado regularmente. Nosso CSSBuy Spreadsheet é mantido com atualizações diárias, garantindo que você sempre tenha acesso aos links mais recentes e vendedores ativos.",
  "faq.q5": "Com que frequência o conteúdo é atualizado?",
  "faq.a5": "Realizamos atualizações diárias. Nossa equipe verifica constantemente os links e vendedores para garantir que todas as informações estejam sempre corretas e atualizadas.",

  // === CTA ===
  "cta.title": "Comece Agora",
  "cta.subtitle": "Descubra links atualizados e vendedores confiáveis",
  "cta.button": "Explorar Agora",

  // === FOOTER ===
  "footer.navigation": "NAVEGAÇÃO",
  "footer.categories": "CATEGORIAS",
  "footer.guides": "GUIAS",
  "footer.legal": "LEGAL",
  "footer.home": "Início",
  "footer.guide": "Guia CSSBuy",
  "footer.safety_page": "Segurança",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "footer.disclaimer": "Disclaimer",
  "footer.brand_tagline": "Guias independentes. Não vendemos produtos.",
  "footer.copyright": "© 2026 cssbuyspreadsheets.mom",

  // === SEO ARTICLE ===
  "seo.back_home": "← Voltar ao Início",
};